import {
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  DUPLICATE_PASSWORD_ERROR,
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  PASSWORD_NOT_VALID_ERROR,
  TOKEN_NOT_VALID_ERROR,
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  INTERNAL_SERVER_ERROR,
} from '../../utils/constants'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { errorCodes, getAPIErrorMessage, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import {
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_ERROR,
  FORGOT_PASSWORD_SUCCESS,
  RESET,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_ERROR,
  UPDATE_PASSWORD_SUCCESS,
} from './ResetPasswordConstants'

const initialState = {
  success: false,
  error: '',
  loading: false,
  emailSentSuccess: false,
  tokenExpired: false,
  emailToVerify: '',
  defaultServerErrorMessage: '',
}

export const resetPasswordReducer = (state = initialState, action = {}) => {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case FORGOT_PASSWORD:
      return {
        ...state,
        emailSentSuccess: false,
        loading: true,
      }
    case UPDATE_PASSWORD:
      return {
        ...state,
        error: '',
        success: false,
        loading: true,
        defaultServerErrorMessage: '',
      }
    case UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        success: true,
        loading: false,
      }
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        emailSentSuccess: true,
        loading: false,
      }
    case UPDATE_PASSWORD_ERROR: {
      let message = ''
      let defaultServerErrorMessage = ''
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.UserFriendlyErrorCode || action.payload.UserFriendlyErrorCode === '') {
        message =
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.payload.UserFriendlyErrorCode ?
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, null, action.payload.extra)
          : ''
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        defaultServerErrorMessage = action.payload.UserFriendlyErrorCode ? action.payload : ''
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        if (action.payload.ErrorCode === TOKEN_NOT_VALID_ERROR) {
          return {
            ...state,
            tokenExpired: true,
            loading: false,
          }
        }
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        message = getAPIErrorMessage(action.payload.ErrorCode)
      }
      return {
        ...state,
        error: message,
        loading: false,
        defaultServerErrorMessage,
      }
    }
    case FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        loading: false,
      }
    case RESET:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
